import React from "react";
export default () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.1112 0.648682L16.2252 23.3514L12.6154 11.8338L0.777832 8.32156L24.1112 0.648682Z"
      fill="white"
    />
  </svg>
);
